import React, { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import Logo from "./Logo";

const links = [
  { href: "/#inicio", label: "Inicio" },
  { href: "/#nosotros", label: "Nosotros" },
  { href: "/#servicios", label: "Servicios" },
  { href: "/#productos", label: "Productos" },
  { href: "/#sectores", label: "Sectores" },
  { href: "/#ventajas", label: "Ventajas" },
  { href: "/#proceso", label: "Cómo Trabajamos" },
  { href: "/#faq", label: "FAQ" },
  { href: "/#contacto", label: "Contacto" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0A1628]/85 backdrop-blur-xl border-b border-white/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="px-3 py-2 text-sm text-slate-300 hover:text-white transition-colors relative group"
            >
              {l.label}
              <span className="absolute bottom-1 left-3 right-3 h-px bg-[#0066FF] scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="/#contacto"
            data-testid="navbar-cta-button"
            className="hidden md:inline-flex items-center gap-2 bg-[#0066FF] hover:bg-[#0052CC] text-white text-sm font-medium px-4 py-2.5 rounded-lg transition-all shadow-lg shadow-[#0066FF]/20 hover:shadow-[#0066FF]/40 hover:-translate-y-0.5"
          >
            Solicitar información
            <ArrowRight className="w-4 h-4" />
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Abrir menú"
            className="lg:hidden text-white p-2 hover:bg-white/5 rounded-lg"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#0A1628]/98 backdrop-blur-xl border-t border-white/10 mt-3"
        >
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="text-slate-200 py-3 px-2 border-b border-white/5 hover:text-[#0066FF] transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#contacto"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-button"
              className="mt-4 bg-[#0066FF] text-white text-center font-medium px-4 py-3 rounded-lg"
            >
              Solicitar información
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
